import styled, { css } from 'styled-components';

import { rem } from '../../utils';
import { ColorBulletProps } from '../ColorBullet';

export const StyledWrapper = styled.div<{
  $variant?: 'bullets' | 'detailed';
}>(
  ({ theme, $variant }) => css`
    display: flex;
    width: 100%;
    flex-direction: column-reverse;
    align-items: center;
    transition: box-shadow ${theme.Transition.Timing.Out};
    cursor: pointer;

    ${$variant !== 'bullets' &&
    css`
      padding: ${rem(theme.Spacing.Size.XSmall)};
      gap: ${rem(theme.Spacing.Size.XSmall)};
      border-radius: ${rem(theme.Border.Radius.Small)};
      box-shadow: inset 0 0 0 ${rem(theme.Border.Size.Small)} ${theme.Color.Neutrals.Border};

      &:hover {
        box-shadow: inset 0 0 0 ${rem(theme.Border.Size.Medium)} ${theme.Color.Brand.Primary};
        transition: box-shadow ${theme.Transition.Timing.In};
        .shuffleIndicator {
          opacity: 1;
        }
      }
    `}
  `
);

export const StyledListWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: flex-start;
    width: 100%;
    overflow: hidden;
    position: relative;
    border-radius: ${rem(theme.Border.Radius.Small)};

    .color-bullet-wrapper {
      flex: 1;
      width: 0; // To make the color bullet take the remaining space
    }
    .color-bullet {
      width: 100%;
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      box-shadow: inset 0 0 0 ${rem(theme.Border.Size.Small)} ${theme.Color.OverlayFixed.Light};
      border-radius: ${rem(theme.Border.Radius.Small)};
      z-index: 1;
      pointer-events: none;
    }
  `
);

export const StyledPaletteBullet = styled.div<{
  $color: string;
  $size: ColorBulletProps['size'];
}>(
  ({ theme, $color, $size }) => css`
    display: flex;
    width: 100%;
    height: ${rem(theme.Icon.Size[$size])};
    background-color: ${$color};
  `
);

export const StyledPaletteGroup = styled.div`
  display: flex;
  width: 100%;
`;

export const StyledPaletteLabel = styled.div`
  display: flex;
  width: 100%;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
`;

export const StyledShuffleHover = styled.div<{ readOnly?: boolean }>`
  position: absolute;
  height: 100%;
  width: 100%;
  display: ${({ readOnly }) => (readOnly ? 'none' : 'flex')};
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
  background-color: ${({ theme }) => theme.Color.OverlayFixed.Default};
  opacity: 0;
  transition: opacity ${({ theme }) => theme.Transition.Timing.Out};
`;
